import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
Vue.use(Router)
export default new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      alias: '/home',
      meta: {
        title: '首页',
        keepAlive: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "login" */ './views/Register.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: '注册',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: '登录'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "product" */ './views/SearchResult.vue'),
      meta: {
        title: '搜索结果',
        keepAlive: true
      }
    },
    {
      path: '/detail/:goodsId',
      name: 'detail',
      component: () => import(/* webpackChunkName: "product" */ './views/ProductDetail.vue'),
      meta: {
        title: '商品详情',
        keepAlive: true
      }
    },
    {
      path: '/buySuccess',
      name: 'buySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/BuySuccess.vue'),
      meta: {
        title: '成功加入购物车'
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/PaySuccess.vue'),
      meta: {
        title: '支付成功'
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/MyCart.vue'),
      meta: {
        title: '我的购物车',
        headHide: true,
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "cart" */ './views/Order.vue'),
      meta: {
        headHide: true,
        title: '填写订单信息'
      }
    },
    {
      path: '/center',
      name: 'center',
      component: () => import(/* webpackChunkName: "center" */ './views/Center/Index.vue'),
      // redirect: '/center/user',
      redirect: { name: 'User' },
      meta: {
        footShow: true
      },
      children: [
        {
          path: 'user',
          name: 'User',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/User.vue'),
          meta: {
            title: '我的个人中心',
            keepAlive: false
          },
        },
        {
          path: 'favourite',
          name: 'favourite',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Favourite.vue'),
          meta: {
            title: '我的收藏',
          },
        },
        {
          path: 'footmark',
          name: 'footmark',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/FootMark.vue'),
          meta: {
            title: '我的足迹'
          },
        },
        {
          path: 'balance',
          name: 'balance',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Balance.vue'),
          meta: {
            title: '我的余额'
          },
        },
        {
          path: 'recharge',
          name: 'recharge',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Recharge.vue'),
          meta: {
            title: '余额充值'
          },
        },
        {
          path: 'myOrder',
          name: 'myOrder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/MyOrder.vue'),
          meta: {
            title: '我的订单'
          },
        },
        {
          path: 'orderDetail/:order_id',
          name: 'orderDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/OrderDetail.vue'),
          meta: {
            title: '订单详情'
          }
        },
        {
          path: 'userInfo',
          name: 'userInfo',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/UserInfo.vue'),
          meta: {
            title: '资料设置'
          }
        },
        {
          path: 'safeCenter',
          name: 'safeCenter',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/SafeCenter.vue'),
          meta: {
            title: '安全中心'
          }
        },
        {
          path: 'address',
          name: 'address',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Address.vue'),
          meta: {
            title: '收货地址'
          }
        },
        {
          path: 'point',
          name: 'point',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Point.vue'),
          meta: {
            title: '我的积分'
          }
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Coupon.vue'),
          meta: {
            title: '我的优惠券'
          }
        },
        {
          path: 'receipt',
          name: 'receipt',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Receipt.vue'),
          meta: {
            title: '我的发票'
          }
        },
        {
          path: 'refund',
          name: 'refund',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/Index.vue'),
          meta: {
            title: '申请退换货'
          },
        },
        {
          path: 'refundDetail/:aftersales_id',
          name: 'refundDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundDetail.vue'),
          meta: {
            title: '退换货详情'
          }
        },
        {
          path: 'refundApply/:order_id',
          name: 'refundApply',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundApply.vue'),
          meta: {
            title: '退换货申请'
          }
        },
        {
          path: 'evaluate',
          name: 'evaluate',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Evaluate.vue'),
          meta: {
            title: '评价订单'
          }
        }
      ]
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/Index.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/cashier/:order_id',
      name: 'cashier',
      component: () => import(/* webpackChunkName: "center" */ './views/Cashier.vue'),
      meta: {
        title: '收银台',
        headHide: true,
      },
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }

  }
})

